import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import {
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    createIcons,
    Globe,
    Link,
    Mail,
    Play,
    Plus,
    Search,
    X,
} from 'lucide';
import Swiper from 'swiper/bundle';

/**
 * Initialize Lucide icons (UI icons)
 */
const initLucideIcons = () => {
    createIcons({
        icons: {
            ArrowDown,
            ArrowLeft,
            ArrowRight,
            ChevronLeft,
            ChevronRight,
            ChevronDown,
            Link,
            Mail,
            Plus,
            Play,
            Globe,
            Search,
            X,
        },
        nameAttr: 'data-lucide',
        attrs: {
            class: 'lucide',
        },
    });
};

document.addEventListener('DOMContentLoaded', function () {

    /** Create Lucide icons on page load **/
    initLucideIcons();

    /** Scroll event on header **/
    const mainHeader = document.getElementById('main-header');
    const headerHeight = mainHeader?.offsetHeight || 0;
    let prevScrollpos = window.scrollY;
    
    window.onscroll = function() {
        const currentScrollPos = window.scrollY;
        
        if (currentScrollPos > (headerHeight * 2)) {
            if (prevScrollpos - currentScrollPos > 10) {
                mainHeader?.classList.remove('scrolled');
                mainHeader?.querySelectorAll('.menu-item-has-children').forEach(el => el.classList.remove('show'));
            } else if (currentScrollPos - prevScrollpos > 10) {
                mainHeader?.classList.add('scrolled');
                mainHeader?.querySelectorAll('.menu-item-has-children').forEach(el => el.classList.remove('show'));
            }
        } else {
            mainHeader?.classList.remove('scrolled');
            mainHeader?.querySelectorAll('.menu-item-has-children').forEach(el => el.classList.remove('show'));
        }

        prevScrollpos = currentScrollPos;
    }

    /** Swiper **/
    const windowWidth = window.innerWidth;
    
    if (windowWidth <= 991) {
        new Swiper('.js_relatedSwiper', {
            direction: 'horizontal',
            slidesPerView: 1.25,
            spaceBetween: 16,
            scrollbar: {
                el: ".js_relatedSwiperScrollbar",
                hide: false,
                draggable: true,
            },
        });

        new Swiper('.js_newsFeedSwiper', {
            direction: 'horizontal',
            slidesPerView: 1.25,
            spaceBetween: 16,
            navigation: {
                nextEl: '.js_newsFeedNext',
                prevEl: '.js_newsFeedPrev',
            },
        });

        new Swiper('.js_projectsParallaxHomeSwiper', {
            direction: 'horizontal',
            slidesPerView: 1.25,
            spaceBetween: 16,
            navigation: {
                nextEl: '.js_projectsParallaxHomeNext',
                prevEl: '.js_projectsParallaxHomePrev',
            },
        });
    }

    let storiesHomeSwiperNext = document.querySelector('.js_storiesHomeNextDesktop');
    let storiesHomeSwiperPrev = document.querySelector('.js_storiesHomePrevDesktop');
    
    if (windowWidth <= 991) {
        storiesHomeSwiperNext = document.querySelector('.js_storiesHomeNextMobile');
        storiesHomeSwiperPrev = document.querySelector('.js_storiesHomePrevMobile');
    }

    new Swiper('.js_storiesHomeSwiper', {
        direction: 'horizontal',
        slidesPerView: 1.25,
        spaceBetween: 16,
        breakpoints: {
            992: {
                slidesPerView: 2.25,
            },
        },
        navigation: {
            nextEl: storiesHomeSwiperNext,
            prevEl: storiesHomeSwiperPrev,
        },
    });

    new Swiper('.js_carouselSwiper', {
        direction: 'horizontal',
        slidesPerView: 1.5,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 1.5,
            },
            992: {
                slidesPerView: 3.25,
            },
        },
        scrollbar: {
            el: ".js_carouselSwiperScrollbar",
            hide: false,
            draggable: true,
        },
    });

    if (windowWidth <= 991) {
        new Swiper('.js_keyfiguresSwiper', {
            direction: 'horizontal',
            slidesPerView: 1.75,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
            },
            scrollbar: {
                el: ".js_keyfiguresSwiperProgressbar",
                hide: false,
                draggable: true,
            },
        });
    }

    new Swiper('.js_carouselPortfolioSwiper', {
        direction: 'horizontal',
        slidesPerView: 1.25,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 1.25,
            },
            992: {
                slidesPerView: 2.3,
            },
        },
        scrollbar: {
            el: ".js_carouselPortfolioSwiperScrollbar",
            hide: false,
            draggable: true,
        },
    });

    /** Acquisition Timeline Swiper **/
    const acquisitionYearLabel = document.querySelector('.js_acquisitionYear');
    const acquisitionSwiper = new Swiper('.js_acquisitionSwiper', {
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 48,
        freeMode: true,
        mousewheel: {
            forceToAxis: true,
        },
        navigation: {
            nextEl: '.js_acquisitionNext',
            prevEl: '.js_acquisitionPrev',
        },
        on: {
            init: function () {
                const year = this.slides[this.activeIndex]?.dataset.year;
                if (acquisitionYearLabel && year) acquisitionYearLabel.textContent = year;
            },
            slideChange: function () {
                const year = this.slides[this.activeIndex]?.dataset.year;
                if (acquisitionYearLabel && year) acquisitionYearLabel.textContent = year;
            },
        },
    });

    /** Video player (inline embed/local) **/
    document.addEventListener('click', function(e) {
        const button = e.target.closest('.btn--play');
        if (!button) return;

        // Skip si c'est un bouton qui ouvre une modale Bootstrap
        if (button.dataset.bsToggle === 'modal') return;

        // Cherche le parent le plus proche contenant un container vidéo
        const parent = button.closest('.page-part--content') || button.closest('.card-wrapper');
        if (!parent) return;

        const videoType = parent.dataset.videoType || 'embed';
        const parentHeight = parent.offsetHeight;
        const videoId = button.dataset.videoId;

        const isStoriesHome = parent.classList.contains('card-wrapper');
        const delay = isStoriesHome ? 600 : 0;
        
        const hideOverlay = () => {   
            if (isStoriesHome) {
                parent.classList.add('played');
            }
            // parent.classList.add('played');
            setTimeout(() => {
                parent.classList.add('played');
                button.style.display = 'none';
                const overlay = parent.querySelector('figure, .illustration--overlay');
                if (overlay) overlay.style.display = 'none';
                const placeholder = parent.querySelector('[data-embed-container], [data-video-container]');
                if (placeholder) placeholder.style.width = '100%';
            }, delay);
        };

        if (videoType === 'embed' || button.dataset.embedIframe) {
            const embedIframe = button.dataset.embedIframe;
            const container = parent.querySelector('[data-embed-container]');
            
            if (container && embedIframe) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = embedIframe.trim();
                const iframe = tempDiv.querySelector('iframe');
                
                if (iframe) {
                    let src = iframe.getAttribute('src');
                    if (src) {
                        src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
                        iframe.setAttribute('src', src);
                    }
                    
                    container.innerHTML = '';
                    container.style.height = `${parentHeight}px`;
                    hideOverlay();
                    setTimeout(() => {
                        container.appendChild(iframe);
                    }, 300);
                }
            }
        } else if (videoType === 'local') {
            const videoUrl = button.dataset.videoUrl;
            const videoMimeType = button.dataset.videoTypeMime;
            const container = parent.querySelector('[data-video-container]');
            container.parentElement.style.height = `${parentHeight}px`;
            if (container && videoUrl) {
                hideOverlay();
                setTimeout(() => {
                    const video = document.createElement('video');
                    video.className = 'page-part-video';
                    video.controls = true;
                    video.autoplay = true;
                    video.preload = 'metadata';
                    video.playsInline = true;
                    
                    const source = document.createElement('source');
                    source.src = videoUrl;
                    source.type = videoMimeType;
                    
                    video.appendChild(source);
                    container.innerHTML = '';
                    container.style.height = `${parentHeight}px`;
                
                    container.appendChild(video);
                }, 300);
            }
        }
    });

    /** 
     * Re-initialize Lucide icons for dynamically loaded content
     * Use MutationObserver to detect DOM changes
     */
    const observer = new MutationObserver((mutations) => {
        let shouldReinit = false;
        
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Element node
                        if (node.querySelector('[data-lucide]') || node.hasAttribute('data-lucide')) {
                            shouldReinit = true;
                        }
                    }
                });
            }
        });
        
        if (shouldReinit) {
            initLucideIcons();
        }
    });

    // Observe the document for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    /** Internal Nav & Anchors **/
    const navInternal = document.getElementById('nav-internal');
    const wrapperSticky = document.querySelector('.wrapper-sticky');
    const anchors = document.querySelectorAll('.js_anchorItemLink');
    const sections = document.querySelectorAll('[data-anchor-id]');
    const navIndicator = document.querySelector('.js_navIndicator');
    const navSelectorMobile = document.querySelector('.js_navSelectorMobile');
    const navSelectorList = document.querySelector('.js_navSelectorList');
    const isMobile = () => window.innerWidth < 992;

    if (navInternal && wrapperSticky) {
        const lastChild = wrapperSticky.lastElementChild;
        const basePadding = lastChild ? parseFloat(getComputedStyle(lastChild).paddingBottom) || 0 : 0;
        const baseSpacing = 32; // espace de base en px

        const updateNavPosition = () => {
            const spacing = isMobile() ? '0px' : '1rem';
            navInternal.style.top = `calc(100% - ${navInternal.offsetHeight}px - ${spacing})`;

            if (lastChild) {
                lastChild.style.paddingBottom = `${basePadding + navInternal.offsetHeight + baseSpacing}px`;
            }

            if (isMobile() && navSelectorList) navSelectorList.style.bottom = `${navInternal.offsetHeight}px`;
        };
        updateNavPosition();
        window.addEventListener('resize', updateNavPosition, { passive: true });
    }

    const closeMobileMenu = () => {
        navSelectorMobile?.classList.remove('active');
        navSelectorList?.classList.remove('active');
    };

    const moveIndicator = (item) => {
        if (isMobile() || !navIndicator) return;
        const nav = item?.closest('.navbar-nav--anchors');
        if (!nav) return;
        const navRect = nav.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        Object.assign(navIndicator.style, {
            width: `${itemRect.width}px`,
            height: `${itemRect.height}px`,
            transform: `translate(${itemRect.left - navRect.left}px, ${itemRect.top - navRect.top}px)`
        });
    };

    // Click sur ancre → scroll + ferme menu mobile
    anchors.forEach(a => a.addEventListener('click', (e) => {
        e.preventDefault();
        closeMobileMenu();
        document.querySelector(`[data-anchor-id="${a.getAttribute('href').slice(1)}"]`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    // Click sur Page Title → ferme menu mobile (le lien natif gère le scroll)
    document.querySelector('.nav-link--page-label')?.addEventListener('click', closeMobileMenu);

    // Observer sections
    if (sections.length) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(({ isIntersecting, target }) => {
                if (!isIntersecting) return;
                const id = target.getAttribute('data-anchor-id');
                anchors.forEach(a => {
                    const isActive = a.getAttribute('href').slice(1) === id;
                    a.parentElement.classList.toggle('active', isActive);
                    if (isActive) moveIndicator(a.parentElement);
                });
            });
        }, { threshold: 0.7 });
        sections.forEach(s => observer.observe(s));
    }

    // Toggle menu mobile
    navSelectorMobile?.addEventListener('click', () => {
        navSelectorMobile.classList.toggle('active');
        navSelectorList?.classList.toggle('active');
    });

    /** Single Anchors Navigation **/
    const navInternalSingle = document.getElementById('nav-internal-single');
    console.log('navInternalSingle:', navInternalSingle);
    if (navInternalSingle) {
        const singleAnchors = navInternalSingle.querySelectorAll('.js_anchorItemLink');
        const singleSections = document.querySelectorAll('[data-anchor-id]');
        console.log('singleAnchors:', singleAnchors.length, 'singleSections:', singleSections.length);

        // Click → smooth scroll
        singleAnchors.forEach(a => a.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector(`[data-anchor-id="${a.getAttribute('href').slice(1)}"]`)
                ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }));

        // Observer sections → active class (basé sur scroll position)
        if (singleSections.length) {
            const updateActiveAnchor = () => {
                const scrollTop = window.scrollY;
                const offset = window.innerHeight * 0.2; // 20% du viewport
                
                let activeSection = null;
                
                // Trouve la section la plus haute qui est passée le seuil
                singleSections.forEach(section => {
                    const sectionTop = section.getBoundingClientRect().top + scrollTop;
                    if (scrollTop + offset >= sectionTop) {
                        activeSection = section;
                    }
                });

                if (activeSection) {
                    const activeId = activeSection.getAttribute('data-anchor-id');
                    singleAnchors.forEach(a => {
                        const isActive = a.getAttribute('href').slice(1) === activeId;
                        a.parentElement.classList.toggle('active', isActive);
                    });
                }
            };

            window.addEventListener('scroll', updateActiveAnchor, { passive: true });
            updateActiveAnchor(); // Init
        }
    }

    // Set Hero Home body height as CSS variable
    const heroHome = document.querySelector('.page-part--hero-home');
    if (heroHome) {
        const heroBody = heroHome.querySelector('.page-part__subpart--body');
        if (heroBody) {
            const setBodyHeight = () => {
                heroHome.style.setProperty('--hero-body-height', `${heroBody.offsetHeight}px`);
            };
            setBodyHeight();
            window.addEventListener('resize', setBodyHeight, { passive: true });
        }
    }

    /** Video Modal - Build iframe on open, destroy on close **/
    const videoModal = document.getElementById('hero-video-modale');
    if (videoModal) {
        const container = videoModal.querySelector('[data-embed-iframe]');
        if (container) {
            const embedIframe = container.dataset.embedIframe;

            videoModal.addEventListener('shown.bs.modal', () => {
                if (embedIframe) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = embedIframe.trim();
                    const iframe = tempDiv.querySelector('iframe');

                    if (iframe) {
                        let src = iframe.getAttribute('src');
                        if (src) {
                            src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
                            iframe.setAttribute('src', src);
                        }
                        container.innerHTML = '';
                        container.appendChild(iframe);
                    }
                }
            });

            videoModal.addEventListener('hidden.bs.modal', () => {
                container.innerHTML = '';
            });
        }
    }

});
